import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ci{background:var(--shades-white);}.ssr-plugin'
import '.c9{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b1{max-width:77.5rem;}.ssr-plugin'
import '.dd{justify-content:stretch;}.ssr-plugin'
import '.de{position:sticky;}.ssr-plugin'
import '.cr{top:0;}.ssr-plugin'
import '.df{z-index:10;}.ssr-plugin'
import '.dn{padding-block:1rem;}.ssr-plugin'
import '.do{height:3rem;}.ssr-plugin'
import '.a1{justify-content:space-between;}.ssr-plugin'
import '.di{flex-wrap:wrap;}.ssr-plugin'
import '.dp{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bg{margin-top:2rem;}.ssr-plugin'
import '.gb{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab g b ci"
      >
        <div className="c9 a c g b"
        >
          <div className="b1 a b dd de cr df"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dn do a a1 c di"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dp a b ab bg gb b1"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
